import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { catchError, forkJoin, of, switchMap } from 'rxjs';
import { ArticleService } from './article.service';
import { DataService } from './data.service';

export const actifResolver = (route: ActivatedRouteSnapshot) => {
    const dataService = inject(DataService);
    const articleService = inject(ArticleService);
    const isin = route.paramMap.get('isin');
    return forkJoin({
        data: dataService.recupererParISIN(isin).pipe(catchError(() => of({}))),
        dividendes: dataService
            .getDividendesByIsin(isin)
            .pipe(catchError(() => of({}))),
        news: articleService
            .getNewsByActif(isin)
            .pipe(
                switchMap((news) => {
                    if (news && news.length > 0) return of(news);
                    return articleService.getNewsByActif('TN0009050014');
                })
            )
            .pipe(catchError(() => of([]))),
    });
};
